import { render, staticRenderFns } from "./URLLink.vue?vue&type=template&id=07e75f12&scoped=true&"
import script from "./URLLink.vue?vue&type=script&lang=js&"
export * from "./URLLink.vue?vue&type=script&lang=js&"
import style0 from "./URLLink.vue?vue&type=style&index=0&id=07e75f12&scoped=true&lang=css&"
import style1 from "./URLLink.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e75f12",
  null
  
)

export default component.exports